import React from "react";
import { COLORS } from "./tokens";

/**
 * SIGNATURE ICON — handwritten "RW"
 * Uses a connected script style. Designed to look good at small sizes
 * and to digitise cleanly for embroidery.
 * Available colors: gold (default), black, white.
 */
const SignatureRW = React.forwardRef(function SignatureRW(
  { size = 240, color = COLORS.gold, id = "rona-signature-rw" },
  ref
) {
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 200"
      width={size}
      height={(size * 200) / 360}
      role="img"
      aria-label="RW signature monogram"
    >
      <g fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round">
        {/* Entry flourish */}
        <path d="M24 140 C 40 120, 56 110, 72 112" strokeWidth="3" />

        {/* R — script capital */}
        {/* downstroke with a soft curl */}
        <path
          d="M72 112
             C 66 90, 64 70, 74 52
             C 82 38, 96 36, 104 48
             C 110 60, 98 76, 82 76
             L 82 76
             C 78 76, 76 74, 76 70"
          strokeWidth="6"
        />
        {/* main stem coming down */}
        <path
          d="M78 64
             C 82 88, 86 112, 92 140
             C 96 156, 92 164, 86 168"
          strokeWidth="6"
        />
        {/* R leg curving out and connecting forward into W */}
        <path
          d="M88 120
             C 104 118, 118 124, 128 138
             C 136 148, 140 156, 150 158"
          strokeWidth="6"
        />

        {/* connecting flourish between R and W */}
        <path d="M150 158 C 162 156, 172 150, 180 140" strokeWidth="3.5" />

        {/* W — flowing script, four strokes undulating */}
        <path
          d="M170 78
             C 176 104, 186 132, 196 158
             C 200 168, 206 168, 212 160
             C 220 148, 226 132, 232 114
             C 236 102, 240 98, 244 108
             C 250 128, 256 148, 264 160
             C 268 166, 274 166, 280 160
             C 290 148, 300 130, 310 106"
          strokeWidth="6"
        />

        {/* Ending flourish — long trailing swash */}
        <path
          d="M310 106
             C 316 96, 322 92, 330 96
             C 338 102, 336 116, 324 122
             C 314 126, 304 122, 300 114"
          strokeWidth="3.5"
        />
      </g>
    </svg>
  );
});

export default SignatureRW;
